module.exports = __webpack_public_path__ + "img/monitor_logo_light.a8f6e17f.svg";